import React from "react";
import { Space, Tooltip } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faCircle } from "@fortawesome/free-solid-svg-icons";
import {
  SidebarCard,
  SidebarButton,
  SidebarSpace,
  SidebarHeader,
  SidebarDescription,
  SidebarIconWrapper,
  SidebarButtonContent,
  SidebarButtonText,
  SidebarButtonDescription,
  SidebarArrowIconWrapper,
  SidebarDivider,
  SidebarSectionTitle,
  SidebarActivityIconWrapper,
  SidebarActivityText,
} from './Styles';
import { SidebarButton as SidebarButtonType, COLOR_MAP } from './Constant';

interface SidebarProps {
  buttons: SidebarButtonType[];
  onButtonClick?: (action: () => void) => void;
}

const Sidebar: React.FC<SidebarProps> = ({ buttons }) => {
  return (
    <SidebarCard>
      <SidebarSpace direction="vertical" size="large">
        <div>
          <SidebarHeader>Quick Actions</SidebarHeader>
          <SidebarDescription>
            Access your most used features
          </SidebarDescription>
        </div>

        <SidebarSpace direction="vertical" size="small">
          {buttons.map((button) => (
            <Tooltip key={button.id} title="Coming Soon" placement="left">
              <SidebarButton
                disabled={true}
                icon={
                  <SidebarIconWrapper
                    color={COLOR_MAP[button.color] || "#1890ff"}
                  >
                    <FontAwesomeIcon icon={button.lefticon} />
                  </SidebarIconWrapper>
                }
              >
                <SidebarButtonContent>
                  <SidebarButtonText>{button.text}</SidebarButtonText>
                  <SidebarButtonDescription>
                    {button.description}
                  </SidebarButtonDescription>
                </SidebarButtonContent>
                <SidebarArrowIconWrapper>
                  <FontAwesomeIcon icon={faArrowRight} />
                </SidebarArrowIconWrapper>
              </SidebarButton>
            </Tooltip>
          ))}
        </SidebarSpace>
        <SidebarDivider />
        <div>
          <SidebarSectionTitle>Recent Activity</SidebarSectionTitle>
          <SidebarSpace direction="vertical" size="small">
            <Space size="small">
              <SidebarActivityIconWrapper color="#52c41a">
                <FontAwesomeIcon icon={faCircle} />
              </SidebarActivityIconWrapper>
              <SidebarActivityText>
                Last order: 2 minutes ago
              </SidebarActivityText>
            </Space>
            <Space size="small">
              <SidebarActivityIconWrapper color="#1890ff">
                <FontAwesomeIcon icon={faCircle} />
              </SidebarActivityIconWrapper>
              <SidebarActivityText>
                Device connected: 5 minutes ago
              </SidebarActivityText>
            </Space>
          </SidebarSpace>
        </div>
      </SidebarSpace>
    </SidebarCard>
  );
};

export default Sidebar;